import styled from 'styled-components';
import cssKit from '../../css';

// Variable to detect if we are on a nissan or infiniti page and style accordingly
const nissan = process.env.BRAND_NAME === 'nissan';

export const StyledAccordionWrapper = styled.div`
  margin-bottom: -1px;
`;

export const StyledAccordionToggle = styled.button`
  outline: none;
  width: 100%;
  text-align: left;
  position: relative;
  border-bottom: 1px solid #d3d3d3;
  border-top: 1px solid #d3d3d3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;

  &[aria-expanded="true"]:after{
    top: ${nissan ? '-36px' : '-38px'};
    content: '-';

    ${cssKit.media.greaterThan('small') `
      top: -48px;
    `}
  }

  &[aria-expanded = "true"] + [aria-hidden="false"] {
    max-height: 1965px;
    padding: 30px 0;

    ${cssKit.media.greaterThan('medium') `
      max-height: 1225px;
    `}
  }

  &:after {
    width: 25px;
    content: '+';
    font-size: 40px;
    margin-left: auto;
    text-align: right;
    margin-bottom: auto;
    margin-top: auto;
    font-family: ${cssKit.fonts.light};

    ${nissan && cssKit.media.greaterThan('small') `
      top: -44px;
    `}
    ${!nissan && cssKit.media.greaterThan('small') `
      top: -49px;
    `}

  }

    h3 {
    padding: 1em 0;
    text-transform: uppercase;
    max-width: 90%;
  }

  [aria-hidden] {
    overflow-y: hidden;
    max-height: 0;
    transition: all .3s ease-in;
  }

  h3, h4 {
    font-family: ${cssKit.fonts.light};
  }

  h2 {
    font-size: 24px;

    ${cssKit.media.greaterThan('small') `
      font-size: 26px;
    `}
  }
`;

export const StyledAccordionBodyContent = styled.span`
  overflow: hidden;
  h4,p {
    font-family: ${cssKit.fonts.regular};
  }


`;



/** WEBPACK FOOTER **
 ** ./src/components/Accordion/styles.js
 **/